import { makeEnum, makeEnumWithData, makeOptions,
  setupClass, lookupData, Matches,
} from '../Base.js'
import { valOr, extendArray, } from '../SharedUtils.js'
import { Field, FieldType, FieldGroup, SelectOrManualInput, } from '../Common/Field.js'
import { YesNo, makeNoYesField, makeYesNoField } from '../Components/Common.js'
import { Schedule } from './Schedule.js'

import { gApp, DebugOn } from '../Globals.js'

/*
A schedule input, with optional diversity factor.
*/
export class ScheduleInput {
  init(opts) {
    this.opts = valOr(opts, {})

    this.name = valOr(this.opts.name, 'Schedule')
    this.schedule = Field.makeTypeSelect(this.name, gApp.proj().schedules, null, {
      errorWhenEmpty: 'You must create a Schedule in the Schedules tab',
      metadata: {
        typeClass: Schedule,
      }
    })

    this.serFields = [
      'schedule',
    ]
    this.childObjs = '$auto'
    this.objInfo = {
      _name: 'Schedule',
      path: 'schedule-input',
    }
  }

  getAnyErrors() {
    let errors = [];
    extendArray(errors, this.schedule.getObjErrors())
    return errors;
  }

  getSchedule() {
    return this.schedule.lookupValue();
  }
};
setupClass(ScheduleInput)